<app>

    <nav-bar
            user="{opts.user}"
            show-filter-bar="{false}"

    ></nav-bar>


    <!--  hero banner   -->
    <section class="demo-hero-5" data-pages="parallax"
             data-pages-bg-image="/static/web/assets/images/real-estate.jpg">
        <div class="container-xs-height full-height hero-gradient">
            <div class="col-xs-height col-middle text-center">
                <h1 class="text-white inner bold">Aeroviewer for Real Estate</h1>
            </div>
        </div>
    </section>
    <!--  End of hero banner   -->

    <!-- Section Title -->
    <section class="p-b-20 p-t-20">
        <div class="container">
            <div class="row">
                <div class="col text-center">
                    <p class="h1 block-title m-b-0">This Use case is more than obvious.</p>
                    <p class="h2 m-t-5 light">
                        In the AEROVIEWER platform there are 800.000 aerial photos and 1.000.000 seconds of aerial video
                        of
                        the entire European Mediterranean Sea coastline.
                    </p>
                </div>
            </div>
        </div>
    </section>
    <!-- End section title -->


    <!-- Contributors section#1 -->
    <section class="bg-master-lightest p-b-60 p-t-60">
        <div class="container">
            <div class="md-p-l-20 md-p-r-20 xs-no-padding">
                <h5 class="block-title hint-text no-margin">All coastal properties,</h5>
                <div class="row">
                    <div class="col">
                        <p class="h1 m-t-5">land, homes, apartments, villas, stores, have been captured in photos and
                            video.</p>
                    </div>
                    <div class="col no-padding xs-p-l-15 xs-p-r-15">
                        <div class="p-l-35 md-p-l-5">
                            <p>Every interested agent or owner can use photos and video that can been found in
                                AEROVIEWER,
                                in order
                                to promote the property and its surroundings as well as its nearby points of interest,
                                like
                                beaches, anchorages, marinas, ports, residential areas, landmarks, etc.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="p-b-50 p-t-50 bg-master-darkest sm-no-margin"
             data-pages-bg-image="/static/web/assets/images/real-estate.png"
             data-bg-overlay="black" data-overlay-opacity="0.3" data-pages="parallax">
        <div class="container p-b-50 p-t-50">
            <div class="row">
                <div class="col text-center">
                    <p class="h1 text-white block-title m-b-0">Example to use photos and/or video</p>
                    <p class="h5 text-white light p-b-10">to Real Estate sites in order
                        to pin-point the place of a property and its surroundings</p>
                </div>
            </div>
        </div>
        <div class="bg-overlay" style="background-color: black; opacity: 0.3;"></div>
    </section>

    <avr-footer></avr-footer>

    <script>

        // import components

        import '../../components/nav-bar/nav-bar.tag.html';
        import '../../components/avr-footer/avr-footer.tag.html';


        // app instance
        const app = this;

    </script>
</app>


// WEBPACK FOOTER //
// avr_eshop/frontend/apps/real-estate/app.tag.html